<template>
	<div v-loading="loading">
		<div class="app-container">
			<div class="el-title">年报信息</div>
			<el-table v-loading="loading" border :data="nbqyjbxxList">
				<el-table-column label="序号" type="index" align="center" show-overflow-tooltip width="50">
				</el-table-column>
				<el-table-column label="年报年度" align="center" prop="ancheyear">
					<template slot-scope="scope">
						<el-tooltip class="item" effect="dark" content="提示:点击查看年报详情" placement="bottom">
							<el-button type="text" @click="handleDetail(scope.row)">
								{{scope.row.ancheyear }}
							</el-button>
						</el-tooltip>
					</template>
				</el-table-column>
				<el-table-column label="年报状态" align="center" prop="ifpub">
					<template slot-scope="scope">
						<el-tag :type="scope.row.ifpub==='2'||scope.row.ifpub==='5'?'success':'info'">
							{{selectDictLabel(ifpubOptions,scope.row.ifpub)}}
						</el-tag>
					</template>
				</el-table-column>

				<el-table-column label="年报时间" align="center" prop="anchedate">
					<template slot-scope="scope">
						{{ parseTime(scope.row.anchedate, '{y}年{m}月{d}日') }}
					</template>
				</el-table-column>
			</el-table>
			<pagination v-show="total>0" :total="total" :page.sync="queryParams.pageNum"
				:limit.sync="queryParams.pageSize" @pagination="getNbQyJbxxList" />
			<el-dialog :title="title" :visible.sync="detailopen " width="60%" append-to-body
				:close-on-click-modal="false">
				<Nbxx :nbjbxx="nbqyjbxx"></Nbxx>
				<div slot="footer" class="dialog-footer" style="text-align: center;position:sticky">
					<el-button @click="detailopen = false">关 闭</el-button>
				</div>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import {
		listNbQyJbxx
	} from "@/api/qygzs/yqyd";
	import Nbxx from "@/views/qygzs/yqyd/qy/nbxx/Nbxx";
	export default {
		name: 'NbQyJbxx',
		components: {
			Nbxx,
		},
		props: {
			//企业内部序号
			pripid: {
				type: String,
				require: true
			}
		},
		watch: {
			pripid(newValue, oldValue) {
				this.init();
			},
			immediate: true,
			deep: true,
		},
		data() {
			return {
				// 年报企业基本信息列表
				nbqyjbxxList: [],
				//年报企业基本信息详情
				nbqyjbxx: {},
				loading: false,
				// 选中数组
				ids: [],
				// 非单个禁用
				single: true,
				// 非多个禁用
				multiple: true,
				//【企业年报基本信息】总条数
				total: 0,
				queryParams: {
					pageNum: 1,
					pageSize: 10,
					pripid: undefined,
				},
				//年报状态字典
				ifpubOptions: [],
				detailopen: false,
				title: undefined,
			}
		},
		created() {
			this.init();
			this.getDicts("fdw_IFPUB").then(response => {
				this.ifpubOptions = response.data;
			});
		},
		methods: {
			init() {
				this.loading = true;
				this.getNbQyJbxxList();
			},
			//获取年报-企业基本信息列表
			getNbQyJbxxList() {
				this.loading = true;
				this.queryParams.pripid = this.pripid;
				listNbQyJbxx(this.queryParams).then(response => {
					this.nbqyjbxxList = response.rows;
					this.total = response.total;
					this.loading = false;
				});
			},
			/* 查看 */
			handleDetail(row) {
				if (row.ifpub < 2) {
					this.msgWarning("没有当前年度的年报信息！");
					return false;
				}
				this.detailopen = true;
				this.title = `年报详情`;
				this.nbqyjbxx = row;
			},
		}
	}
</script>

<style scoped>
	/deep/ .el-descriptions__header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 0px;
	}

	.el-title {
		box-sizing: border-box;
		font-size: 16px;
		font-weight: 700;
		color: #303133;
		padding-top: 10px;
		text-align: left;
	}
</style>
